/**
 * @generated SignedSource<<068f9ef3a5e01d86759aca7c283aaa6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveAllStudyPanelRecruitsInput = {
  clientMutationId?: string | null;
  excludeIds: ReadonlyArray<string>;
  recruitId: string;
};
export type RecruitMatch_removeAllStudyPanelRecruits_Mutation$variables = {
  input: RemoveAllStudyPanelRecruitsInput;
};
export type RecruitMatch_removeAllStudyPanelRecruits_Mutation$data = {
  readonly removeAllStudyPanelRecruits: {
    readonly errors: ReadonlyArray<{
      readonly data: any | null;
      readonly message: string | null;
    } | null> | null;
    readonly study: {
      readonly id: string;
    } | null;
  } | null;
};
export type RecruitMatch_removeAllStudyPanelRecruits_Mutation = {
  response: RecruitMatch_removeAllStudyPanelRecruits_Mutation$data;
  variables: RecruitMatch_removeAllStudyPanelRecruits_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveAllStudyPanelRecruitsPayload",
    "kind": "LinkedField",
    "name": "removeAllStudyPanelRecruits",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudyNode",
        "kind": "LinkedField",
        "name": "study",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "data",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecruitMatch_removeAllStudyPanelRecruits_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecruitMatch_removeAllStudyPanelRecruits_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dd39e650732454a3c3cc5d8d909a6f06",
    "id": null,
    "metadata": {},
    "name": "RecruitMatch_removeAllStudyPanelRecruits_Mutation",
    "operationKind": "mutation",
    "text": "mutation RecruitMatch_removeAllStudyPanelRecruits_Mutation(\n  $input: RemoveAllStudyPanelRecruitsInput!\n) {\n  removeAllStudyPanelRecruits(input: $input) {\n    study {\n      id\n    }\n    errors {\n      message\n      data\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f2e18951d43e0e14a69881e8fe813a39";

export default node;
